import React from 'react'
import TextField from 'material-ui/TextField'
import MenuItem from 'material-ui/Menu/MenuItem'
import Grid from 'material-ui/Grid'

const VehicleSelector = ({
  options, year, setYear, yearsLoading,
  make, setMake, makesLoading,
  model, setModel, modelsLoading,
  trim, setTrim, trimsLoading, handleChange }) =>
  <Grid container>
    <Grid item xs={3}>
      <TextField
        id="select-year"
        disabled={yearsLoading}
        select
        fullWidth
        label="Year"
        value={year}
        onChange={e => {
          setYear(e.target.value)
          handleChange('year', e.target.value)
        }}
        margin="normal"
      >
        {yearsLoading && <MenuItem key={'none'} value={'none'} />}
        {options && options.years && options.years.map(option => (
          <MenuItem key={option} value={option}>
            {option}
          </MenuItem>
        ))}
      </TextField>
    </Grid>
    <Grid item xs={3}>
      <TextField
        id="select-make"
        select
        fullWidth
        disabled={year === '' || makesLoading}
        label="Make"
        value={make}
        onChange={e => {
          setMake(e.target.value)
          handleChange('make', e.target.value)
        }}
        margin="normal"
      >
        {makesLoading && <MenuItem key={'none'} value={'none'} />}
        {options && options.makes && options.makes.map(option => (
          <MenuItem key={option.id} value={option.id}>
            {option.name}
          </MenuItem>
        ))}
      </TextField>
    </Grid>
    <Grid item xs={3}>
      <TextField
        id="select-model"
        select
        fullWidth
        disabled={make === '' || modelsLoading}
        label="Model"
        value={model}
        onChange={e => {
          setModel(e.target.value)
          handleChange('model', e.target.value)
        }}
        margin="normal"
      >
        {modelsLoading && <MenuItem key={'none'} value={'none'} />}
        {options && options.models && options.models.map(option => (
          <MenuItem key={option} value={option}>
            {option}
          </MenuItem>
        ))}
      </TextField>
    </Grid>
    <Grid item xs={3}>
      <TextField
        id="select-trim"
        select
        fullWidth
        disabled={model === '' || trimsLoading}
        label="Trim"
        value={trim}
        onChange={e => {
          setTrim(e.target.value)
          handleChange('trim', e.target.value)
        }}
        margin="normal"
      >
        {trimsLoading && <MenuItem key={'none'} value={'none'} />}
        {options && options.trims && options.trims.map(option => (
          <MenuItem key={option} value={option}>
            {option}
          </MenuItem>
        ))}
      </TextField>
    </Grid>
  </Grid>

export default VehicleSelector


// WEBPACK FOOTER //
// ./src/modules/vehicles/components/VehicleSelector.js